export const Hr = () => {
  return <hr style={{borderWidth: 1, borderTop: 'none'}} />
}